module.exports = __webpack_public_path__ + "static/media/a-dark-song.0044337a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/a-dark-song.jpg
// module id = 280
// module chunks = 0